// extracted by mini-css-extract-plugin
export default {"timestamp":"styles_timestamp__crgY4","table":"styles_table__EeLXe","list":"styles_list__sU84W","header":"styles_header__0EKb1","button":"styles_button__i1CHY"};